import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { pickTrackedParams, type TrackedParams } from '@/utils/signupUrl'

const STORAGE_KEY = 'wealthspace-utm-params'

const readStored = (): TrackedParams => {
  if (typeof window === 'undefined') return {}
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as TrackedParams) : {}
  } catch {
    return {}
  }
}

const writeStored = (params: TrackedParams): void => {
  if (typeof window === 'undefined') return
  try {
    if (Object.keys(params).length === 0) {
      window.sessionStorage.removeItem(STORAGE_KEY)
    } else {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params))
    }
  } catch {
    // Storage may be disabled (private mode, quota); ignore.
  }
}

export function useUtmPassthrough(): TrackedParams {
  const { search } = useLocation()

  const incoming = useMemo(
    () => pickTrackedParams(new URLSearchParams(search)),
    [search],
  )

  const merged = useMemo<TrackedParams>(() => {
    return { ...readStored(), ...incoming }
  }, [incoming])

  useEffect(() => {
    if (Object.keys(incoming).length === 0) return
    writeStored(merged)
  }, [incoming, merged])

  return merged
}
